<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Empresa</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Empresa</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <div class="container-fluid">
      <div class="row mb-4">
        <div class="col-12 col-sm-6 col-lg-3">
          <div id="btn-agregar-empresa" class="info-box shadow-sm action-card" @click="nuevaEmpresa(null)" data-target="#empresaModal" data-toggle="modal">
            <span class="info-box-icon bg-info elevation-1"><i class="fas fa-plus"></i></span>
            <div class="info-box-content">
              <span class="info-box-text text-bold">Nueva Empresa</span>
              <span class="info-box-number text-muted small">Registrar datos</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card card-outline card-primary shadow">

            <div class="card-header">
              <h3 class="card-title text-muted">
                <i class="fas fa-list mr-2"></i> Listado de empresas registradas
              </h3>
            </div>

            <div class="card-body p-0 p-md-3">
              <!-- VISTA TABLA -->

              <table id="tablaEmpresa" class="table table-hover table-striped w-100">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Rif</th>
                    <th>Dirección</th>
                    <th>Contacto</th>
                    <th>Email</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
            <!-- Modal / Formulario -->
            <formEmpresa :empresa="empresaActual" @success="obtenerempresas" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import { tutorial } from "@/plugins/tutorial";
import FormEmpresa from "@/components/FormEmpresa.vue";


export default {
  components: { FormEmpresa },

  setup() {
    const dt = ref(null);
    const empresas = ref([]);
    const empresaActual = ref(null);
    const { proxy } = getCurrentInstance();
    // 1) Carga y pinta la tabla
    async function obtenerempresas() {
      const { data } = await api.get("/empresa");
      empresas.value = data;

      await nextTick();

      if (!dt.value && window.$ && $.fn.DataTable) {
        dt.value = $("#tablaEmpresa").DataTable({
          data: empresas.value,
          responsive: true,
          autoWidth: false,
          columns: [
            { data: "nombre", title: "Nombre" },
            { data: "rif", title: "RIF" },
            { data: "direccion", title: "Dirección" },
            { data: "contacto", title: "Contacto" },
            { data: "email", title: "Email" },
            {
              data: null,
              title: "Opciones",
              orderable: false,
              className: "text-center",
              render: (row) => `
                <button class="btn btn-warning editar" data-id="${row.id}">
                  <i class="fas fa-pen-to-square"></i>
                </button>
                <button class="btn btn-danger eliminar" data-id="${row.id}">
                  <i class="fas fa-trash"></i>
                </button>
              `
            }
          ],
          pageLength: 10,
          lengthChange: false,
          pagingType: "numbers",
          language: {
            url:
              "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
          },
          dom:
            '<"row mb-3"<"col-12 col-md-6"f>>' +
            "t" +
            '<"row mt-3"<"col-12 text-center"i>>' +
            '<"row"<"col-12 d-flex justify-content-center"p>>'
        });

        // 2) Delegamos clicks sobre los botones que inyectó DataTables
        const table = dt.value;
        $("#tablaEmpresa tbody")
          .on("click", "button.editar", async (e) => {
            const row = $(e.currentTarget).closest("tr");
            const data = table.row(row).data();
            editarEmpresa(data);
          })
          .on("click", "button.eliminar", async (e) => {
            const row = $(e.currentTarget).closest("tr");
            const data = table.row(row).data();
            await eliminarEmpresa(data);
          });
      } else if (dt.value) {
        // Si ya existe, actualizamos el data y redibujamos
        dt.value.clear().rows.add(empresas.value).draw();
      }
    }

    // Nueva empresa: limpia la ref y abre modal
    function nuevaEmpresa() {
      empresaActual.value = null;
      nextTick(() => $("#empresaModal").modal("show"));
    }

    // Editar: setea la ref y abre modal en nextTick
    function editarEmpresa(emp) {
      empresaActual.value = emp;
      nextTick(() => $("#empresaModal").modal("show"));
    }

    // Eliminar con confirm y refresco de DataTable
    async function eliminarEmpresa(emp) {
      proxy.$alert({
        title: '¿Deseas eliminar esta empresa?',
        text: `Estás a punto de eliminar a "${emp.nombre}". Esta acción no se puede deshacer.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      }).then(async (res) => {
          if (!res.isConfirmed) return;

          try {
            await api.delete(`/empresa/${emp.id}`);
            // Si llegamos aquí, el borrado fue exitoso (204)
            empresas.value = empresas.value.filter(e => e.id !== emp.id);
            if (dt.value) {
              dt.value.clear().rows.add(empresas.value).draw();
            }
            proxy.$toast({ icon: 'success', title: 'Empresa eliminada con éxito' });
          } catch (err) {
            // CAPTURA DEL ERROR 403 (O CUALQUIER OTRO)
            console.error("Error capturado:", err);
            const errorData = err.response?.data;
            const tituloError = errorData?.message || 'Error al eliminar';
            const cuerpoError = errorData?.detalles || 'No se pudo completar la operación.';
            proxy.$alert({
              icon: 'error',
              title: tituloError,
              text: cuerpoError
            });
          }
        });
    }

    // Definición de pasos del tutorial
    function iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-empresa',
          title: 'Nueva Empresa',
          text: 'Haz clic en este recuadro para registrar una nueva empresa en el sistema.',
          position: 'bottom'
        },
        {
          element: '.card-body', // Apuntamos al cuerpo de la tarjeta donde está la tabla
          title: 'Listado de Empresas',
          text: 'Aquí verás la lista de empresas registradas.',
          position: 'top'
        }
      ];

      const table = $('#tablaEmpresa');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');

        // Si la fila ya está expandida, la colapsamos para reiniciar el tutorial
        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '#tablaEmpresa tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) o en la primera columna para ver los datos ocultos y las acciones.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        // Listener para habilitar/deshabilitar el botón Siguiente al expandir/colapsar
        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function() {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if ($(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });

        steps.push({
          element: '.dtr-details .editar',
          title: 'Editar Empresa',
          text: 'Haz clic en el botón amarillo para modificar los datos de una empresa existente.',
          position: 'left'
        });

        steps.push({
          element: '.dtr-details .eliminar',
          title: 'Eliminar Empresa',
          text: 'Haz clic en el botón rojo para eliminar una empresa. ¡Cuidado! Esta acción requiere confirmación.',
          position: 'left'
        });
      } else {
        steps.push({
          element: '.editar',
          title: 'Editar Empresa',
          text: 'Haz clic en el botón amarillo para modificar los datos de una empresa existente.',
          position: 'left'
        });

        steps.push({
          element: '.eliminar',
          title: 'Eliminar Empresa',
          text: 'Haz clic en el botón rojo para eliminar una empresa. ¡Cuidado! Esta acción requiere confirmación.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }


    onMounted(() => {
      obtenerempresas();
      // Registramos este tutorial como el activo
      tutorial.set(iniciarTutorial);
    });

    onBeforeUnmount(() => {
      // Limpiamos el registro al salir
      tutorial.set(null);
      if (dt.value) {
        dt.value.destroy();
        dt.value = null;
      }
    });

    return {
      empresas,
      empresaActual,
      nuevaEmpresa,
      editarEmpresa,
      eliminarEmpresa,
      obtenerempresas
    };
  }
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}

.action-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.action-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.12) !important;
}
</style>